// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-textcenter {
    text-align: center;
}
.lr-pad {
    padding-left: 20px;
    padding-right: 20px;
}
.lr-heading {
    margin-bottom: 26px;
}
.lr-intro {
    margin-bottom: 27px;
}
.lr-list {
    padding-left: 0;
    margin-bottom: 34px;
    margin-right: 25px;
}
.lr-list li {
    list-style: none;
    display: -webkit-inline-box;
    margin-bottom: 8px;
}
.lr-list li img{
    padding-right: 10px;
}
.lr-btn {
    margin-bottom: 32px;
}
.lr-back-link {
    display: block;
    text-align: center;
    margin-bottom: 55px;
}
.lr-success-icon {
    height:50.5px;
    width:50.5px
}
.lr-button-separation {
    margin-bottom: 32px;
}
.olr-icon-checkmark {
    background-image: url('icon-checkmark.svg');
    width: 24px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
}
.olr-icon-success_stroke {
    background-image: url('success_stroke_32.svg');
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 auto;
    display: block;
}

@media(min-width: 768px) {
    .lr-pad {
        padding-left: 0;
        padding-right: 0;
    }
    .lr-heading {
        margin-bottom: 19px;
    }
    .lr-intro {
        margin-bottom: 29px;
    }
    .lr-list {
        margin-bottom: 56px;
    }
}
@media(min-width: 1200px) {
    .lr-heading {
        margin-bottom: 23px;
    }
    .lr-intro {
        font-weight: normal;
        font-size: 25px;
        line-height: 38px;
        color: #000;
        margin-bottom: 32px;
    }
    .lr-list {
        margin-bottom: 34px;
    }
}
.olr-nowrap {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/confirmation/received-property-claim/received-property-claim.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb;AACJ;AACA;IACI,mBAAmB;AACvB;AACA;IACI,2CAA6D;IAC7D,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,cAAc;AAClB;AACA;IACI,8CAAgE;IAChE,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".lr-textcenter {\n    text-align: center;\n}\n.lr-pad {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.lr-heading {\n    margin-bottom: 26px;\n}\n.lr-intro {\n    margin-bottom: 27px;\n}\n.lr-list {\n    padding-left: 0;\n    margin-bottom: 34px;\n    margin-right: 25px;\n}\n.lr-list li {\n    list-style: none;\n    display: -webkit-inline-box;\n    margin-bottom: 8px;\n}\n.lr-list li img{\n    padding-right: 10px;\n}\n.lr-btn {\n    margin-bottom: 32px;\n}\n.lr-back-link {\n    display: block;\n    text-align: center;\n    margin-bottom: 55px;\n}\n.lr-success-icon {\n    height:50.5px;\n    width:50.5px\n}\n.lr-button-separation {\n    margin-bottom: 32px;\n}\n.olr-icon-checkmark {\n    background-image: url(../../../assets/img/icon-checkmark.svg);\n    width: 24px;\n    height: 20px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: block;\n}\n.olr-icon-success_stroke {\n    background-image: url(../../../assets/img/success_stroke_32.svg);\n    width: 50px;\n    height: 50px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin: 0 auto;\n    display: block;\n}\n\n@media(min-width: 768px) {\n    .lr-pad {\n        padding-left: 0;\n        padding-right: 0;\n    }\n    .lr-heading {\n        margin-bottom: 19px;\n    }\n    .lr-intro {\n        margin-bottom: 29px;\n    }\n    .lr-list {\n        margin-bottom: 56px;\n    }\n}\n@media(min-width: 1200px) {\n    .lr-heading {\n        margin-bottom: 23px;\n    }\n    .lr-intro {\n        font-weight: normal;\n        font-size: 25px;\n        line-height: 38px;\n        color: #000;\n        margin-bottom: 32px;\n    }\n    .lr-list {\n        margin-bottom: 34px;\n    }\n}\n.olr-nowrap {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
